<script>
import { mapActions, mapState } from 'vuex';

import LogoHeader from '@/components/onboarding/logo-header.vue';

export default {
  name: 'RouletteName',
  components: {
    LogoHeader,
  },
  data() {
    return {
      name: null,
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.onboarding.isUpdatingOnboarding,
      showOnboarding: (state) => state.login.showOnboarding,
    }),
  },
  watch: {
    showOnboarding(newValue) {
      if (!newValue) {
        this.$router.replace({ name: '/' });
      }
    },
  },
  methods: {
    ...mapActions(['setFormValue', 'updateOnboardingStep']),
    async handleContinue() {
      const nextPage = 'trial-explainer';
      this.setFormValue({ field: 'name', value: this.name });
      const response = await this.updateOnboardingStep(nextPage);
      if (!response) {
        // eslint-disable-next-line
        console.error('Error saving data. Please try again.');
        return;
      }

      this.$router.push({ name: nextPage });
    },
  },
};
</script>

<template>
  <div id="main-container" class="container-fluid">
    <div class="row inner-container">
      <div class="col-6 panel">
        <logo-header />
        <div class="row">
          <div class="my-5 text-center">
            <h3 class="my-4">Name your roulette</h3>

            <h5 class="text-muted my-5">
              You can change this later and nothing goes live until you activate
            </h5>

            <b-form-input
              v-model="name"
              size="lg"
              placeholder="Taco Tuesday Chats, Coffee Meetups, etc."
              class="mb-4"
            ></b-form-input>

            <b-button block variant="primary" size="lg" @click="handleContinue" :disabled="loading"
              >Continue</b-button
            >
            <div class="mt-5">
              <h1 class="used-by-text">Used by 600+ happy teams!</h1>
              <img
                src="@/assets/team-logos.png"
                alt="Remote Teams"
                fluid
                width="100%"
                class="mt-2"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 panel light-blue">
        <b-progress :value="60" class="progress-container" />

        <div class="text-center mt-5">
          <img src="@/assets/onboarding-4.png" alt="Remote Teams" fluid width="100%" class="mt-5" />
        </div>
        <div class="card mt-5">
          <div class="card-body">✅ Customize team introduction messages</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#main-container .inner-container {
  min-height: 100vh;
}

.inner-container .panel {
  padding: 70px;
}

.inner-container .light-blue {
  background-color: #f4f7fc;
}

.used-by-text {
  color: #222e3f;
  font-weight: 600;
  line-height: 140%;
  font-size: 34px;
  font-style: italic;
}
</style>
